import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const styles = {
  container: {
    maxWidth: 420,
    margin: "50px auto",
    padding: 30,
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    borderRadius: 10,
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    backgroundColor: "#fff",
  },
  title: {
    textAlign: "center",
    marginBottom: 25,
    color: "#333",
    fontWeight: "700",
    fontSize: "1.8rem",
  },
  formGroup: {
    marginBottom: 20,
  },
  label: {
    display: "block",
    marginBottom: 6,
    color: "#555",
    fontWeight: "600",
    fontSize: 14,
  },
  input: {
    width: "100%",
    padding: "10px 14px",
    fontSize: 15,
    borderRadius: 6,
    border: "1.5px solid #ccc",
    outline: "none",
    transition: "border-color 0.3s",
  },
  inputFocus: {
    borderColor: "#6c5bf3",
  },
  button: {
    width: "100%",
    padding: "12px 0",
    backgroundColor: "#6c5bf3",
    color: "#fff",
    fontWeight: "700",
    fontSize: 16,
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    transition: "background-color 0.3s",
  },
  buttonHover: {
    backgroundColor: "#0056b3",
  },
  message: {
    textAlign: "center",
    marginBottom: 15,
    fontWeight: "600",
  },
  error: {
    color: "#e74c3c",
  },
  success: {
    color: "#27ae60",
  },
};

export default function PasswordReset() {
  const { uidb64, token } = useParams();
  const navigate = useNavigate();

  const [user, setUser] = useState({ email: "", password: "" });
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isResetPage, setIsResetPage] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const encodedEmail = queryParams.get("email");

    if (encodedEmail) {
      const decodedEmail = atob(encodedEmail);
      setEmail(decodedEmail);
      setUser((prevUser) => ({ ...prevUser, email: decodedEmail }));
    }

    if (uidb64 && token) {
      setIsResetPage(true);
    }
  }, [uidb64, token]);

  const handleRequestReset = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const res = await axios.post("https://abha.ai:8004/password-reset/", {
        email,
      });
      setMessage("Redirecting to password reset page...");
      navigate(`/password-reset-confirm/${res.data.uid}/${res.data.token}`);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
    }
  };

  const handleConfirmReset = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    try {
      const res = await axios.post(
        `https://abha.ai:8004/password-reset-confirm/${uidb64}/${token}/`,
        { password }
      );
      setMessage(res.data.message);

      const encodedEmail = btoa(res.data.email);
      setTimeout(() => navigate(`/login?email=${encodedEmail}`), 1500);
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>
        {isResetPage ? "Set New Password" : "Request Password Reset"}
      </h2>

      {error && (
        <p style={{ ...styles.message, ...styles.error }} role="alert">
          {error}
        </p>
      )}
      {message && (
        <p style={{ ...styles.message, ...styles.success }} role="status">
          {message}
        </p>
      )}

      {!isResetPage ? (
        <form onSubmit={handleRequestReset} noValidate>
          <div style={styles.formGroup}>
            <label htmlFor="email" style={styles.label}>
              Email Address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="your.email@example.com"
              style={styles.input}
            />
          </div>

          <button type="submit" style={styles.button}>
            Send Reset Link
          </button>
        </form>
      ) : (
        <form onSubmit={handleConfirmReset} noValidate>
          <div style={styles.formGroup}>
            <label htmlFor="password" style={styles.label}>
              New Password
            </label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="Enter new password"
              style={styles.input}
              minLength={6}
            />
          </div>

          <button type="submit" style={styles.button}>
            Reset Password
          </button>
        </form>
      )}
    </div>
  );
}
